import { useRef } from 'react';

import { useTrigger } from '~/hooks/useTrigger';

interface ITooltipEventTracker {
  onFocus: () => void;
  onBlur: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export const useTooltipEventTracker = (): [boolean, ITooltipEventTracker] => {
  const [open, hook] = useTrigger();
  const ref = useRef(0);

  return [open, {
    onFocus: () => {
      ref.current++;
      hook.activate();
    },
    onBlur: () => {
      ref.current--;
      // blur of an element within the tooltip happens after the next element receive focus
      // this ensures that deactivate it's called if it's the last blur event
      if (ref.current === 0) {
        hook.deactivate();
      }
    },
    onMouseEnter: () => {
      ref.current++;
      hook.activate()
    },
    onMouseLeave: () => {
      ref.current--;
      hook.deactivate()
    },
  }];
}
